/** UUID with a non-crypto fallback for environments without `crypto.randomUUID`. */
export function newUuid(): string {
  try {
    return globalThis.crypto.randomUUID();
  } catch {
    return `id-${Date.now().toString(36)}-${Math.floor(Math.random() * 1e9).toString(36)}`;
  }
}
